import $ from 'jquery';
import { TimelineMax, TweenMax, RoughEase, Power0} from 'gsap';
import { pingAnalyticsUrl} from './actions/actions';

export function changeViewAnimation(view, prev, cb) {
    switch(true){
        case (prev === view):
            $('.scene').scrollTop(0);
            cb();
            break;
        case ((prev === 'intro') && (view === 'questions')):
            // run function
            // pingAnalyticsUrl('953921');
            startQuizTransition(cb);
            // dispatch action
            break;
        case ((prev === 'questions') && (view === 'results')):
            // run function
            resultTransition(cb);
            // dispatch action
            break;
        case ((prev === 'detail') && (view === 'info')):
            $('.scene').scrollTop(0);
            cb();

            break;
        case ((prev === 'detail') && (view === 'results')):
            $('.scene').scrollTop(0);
            cb();

            break;
        default:
            // default block
            defaultTransition(cb);
    }


}
function defaultTransition(cb) {
    let tl = new window.TimelineMax({

    });

    tl.to('.js-curtain-transition', 0.5, {
        y: '100%',
        ease: window.Power2.easeInOut
    })
    .add(function() {
      // change state
    //   $('.curtain--loading').addClass('is-playing');
      $('.scene').scrollTop(0);
      cb();
    })
    .to({}, 1.1, {})
    .to('.js-curtain-transition', 0.7, {
        y: '-100%',
        ease: window.Power2.easeInOut
    }) ;
}
function resultTransition(cb) {
    let tl = new window.TimelineMax({

    });

    tl.to('.js-curtain-result', 0.5, {
        y: '100%',
        ease: window.Power2.easeInOut
    })
    .add(function() {
      // change state
    //   $('.curtain--loading').addClass('is-playing');
      $('.scene').scrollTop(0);
      cb();
    })
    .to({}, 2.5, {})
    .to('.js-curtain-result', 0.7, {
        y: '-100%',
        ease: window.Power2.easeInOut
    }) ;
}
function startQuizTransition(cb) {
    let tl = new window.TimelineMax({

    });

    tl.to('.js-curtain-quiz-start', 0.5, {
        y: '100%',
        ease: window.Power2.easeInOut
    })
    .add(function() {
      // change state
    //   $('.curtain--loading').addClass('is-playing');
      $('.scene').scrollTop(0);
      cb();
    })
    .to({}, 1.1, {})
    .to('.js-curtain-quiz-start', 0.7, {
        y: '-100%',
        ease: window.Power2.easeInOut
    }) ;
}

// function introToQuestions(cb) {
//     cb();
// }

// function cardSwitchAnimation(cb) {
//     let card = $('.wreath__card');
//     let questions = $('.wreath__card-questions');
//
//     let tl = new window.TimelineMax({
//       onComplete() {
//         // change state
//         // cb();
//       }
//     });
//
//     tl.to(card, 0.1, {y:5}, 'cardOut')
//     .to(questions, 0.1, {autoAlpha: 0,y:5}, 'cardOut')
//     .add(function() {
//       // change state
//       cb();
//       // selectChoice(answer, personality);
//     })
//     .to(card, 0.1, {y:0}, 'cardIn')
//     .to(questions, 0.1, {autoAlpha: 1,y:0}, 'cardIn')
// }



/** WEBPACK FOOTER **
 ** ./src/animations.js
 **/